/* eslint-disable no-dupe-class-members */
/* eslint-disable react/no-direct-mutation-state */
import React, { Component } from "react";
import { connect } from "react-redux";
import Moment from "moment";
import Highlighter from "react-highlight-words";
import "tippy.js/dist/tippy.css";
import "tippy.js/dist/themes/light.css";
import MicroModal from "micromodal";
import {
  sendtypinwebsocket,
  InviteMessagesMonitoring,
  SharedScreen,
  InitialMonitoring,
  sendFurtClient,
  changeDisplayByeChat,
} from "../actions/websocket";
import SOUNDWAVE from "../build/images/sound-wave.png";
import WHATSAPPICON from "../build/images/whatsapp_new.svg";
import FACEBOOKICON from "../build/images/facebook_new.svg";
import WEBCHATICON from "../build/images/webchat-new.svg";
import MONITORIAFUTURA from "../build/images/monitoria-futura.png";
import { ReactComponent as GESTOR } from "../build/images/gestor.svg";
import TWITTER from "../build/images/twitter-new.svg";
import MIDIAEMAIL from "../build/images/email-new.svg";
import MIDIATELEGRAM from "../build/images/telegram-new.svg";
import GOOGLEGBM from "../build/images/googlegbm-new.svg";
import LINKEDIN from "../build/images/linkedin-new.svg";
import INSTAGRAM from "../build/images/instagram_new.svg";
import DEFAULT from "../build/images/default.png";
import TimeCounter from "../containers/TimeCounter";
import latinize from "latinize";
import AVI from "../build/images/avi-file.png";
import JPG from "../build/images/jpg-file.png";
import PDF from "../build/images/pdf-file.png";
import MP3 from "../build/images/mp3-file.png";
import ModalImage from "react-modal-image";
import Details from "../containers/Details";
import TEAMS from "../build/images/channels/teamsMedium.svg";
import {
  ShowVisibleDetailsAtd,
  CloseMonitoring,
  RespostasRapidasida,
  SendNextMonitoring,
  addMonitoring,
  senfFileQuickAswMonitoring,
  addMessage,
  InsertUploadMonitoring,
  EditTypeMonitorings,
  EditTypeMonitoringm,
  addMonitoringSimult,
  DetailsAnotationsida,
  InsertAnotations,
  ByeClientMonitoring,
} from "../actions";
import { ReactComponent as FALARATENDENTE } from "../build/images/falar-com-atendente.svg";
import { ReactComponent as SIGILOSA } from "../build/images/sigilosa.svg";
import { ReactComponent as SUSURRO } from "../build/images/sussurro.svg";
import { ReactComponent as MONITORAR } from "../build/images/monitorar.svg";
import { ReactComponent as INTERCALAR } from "../build/images/intercalar.svg";
import { ReactComponent as LOADING } from "../build/images/loading.svg";
import { ReactComponent as TRANSFERICON } from "../build/images/icons/transfer-client-icon2.svg";
import { ReactComponent as TRANSFERICON2 } from "../build/images/icons/transfer-client-icon2.svg";
import { ReactComponent as ENCERRARATENDIMENTO } from "../build/images/icons/byeatendant-client-icon.svg";
import ChatSimultComponent from "../containers/ChatSimult";
import { Popover, Tooltipp, Topover } from "../actions/Tippy";
import _ from "lodash";
import TransferClient from "../containers/TransferClient";
import UserPhoto from "./UserPhoto/userphoto";
import TimeCounterMinute from "../containers/TimeCounterMinute";
const { meses } = require("../services/data");
const { connection_platform } = require("../services/api");

var i = 0;
var typingTimer;
var doneTypingInterval = 5000;
var digitando = 0;
var valorInput = "";

var gethostname = window.location.hostname;
var pathname = "";

var iplocal = connection_platform.ip_intern;
var port = connection_platform.port_backend_intern;

if (gethostname === "localhost") pathname = iplocal;
else pathname = gethostname;

var ipcurrent = pathname;

if (pathname !== connection_platform.ip_intern) {
  ipcurrent = connection_platform.ip_apache_view_extern;
  //if(parseInt(connection_platform.port_apache_view_extern) !== 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_extern;
  //}
} else {
  ipcurrent = connection_platform.ip_apache_view_intern;
  // if(parseInt(connection_platform.port_apache_view_intern) !== 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_intern;
  //}
}

MicroModal.init();

function makeid(length) {
  var text = "";
  var possible =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (var i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
}

function createJSON(item) {
  if (item) {
    var mensagem_tratada = item.replace(/¿/gi, "\n");
    mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
    let valor = 1;
    try {
      mensagem_tratada =
        '{"' + valor + '": [{"mensagem_tratada":"' + mensagem_tratada + '"}]}';
      var obj = JSON.parse(mensagem_tratada);
      mensagem_tratada = obj[1][0].mensagem_tratada;
    } catch (e) {
      mensagem_tratada = item;
    }
    return mensagem_tratada;
  }
}

const mapStateToProps = (state) => {
  return {
    Monitoring: state.monitoring,
    MonitoringSimult: state.monitoringsimult,
    TimeStatusAgent: state.timestatus,
    Typing: state.typing,
    UsersAgents: state.agents,
    Messages: state.messages,
    InfoUsers: state.informationusers,
    IPCurrent: state.ipcurrent,
    DisplayDetails: state.displaydetailsatd,
    ClientUserMonitors: state.clientusermonitors,
    CriticidadesAnotacoes: state.criticalitys,
    RespostasRapidas: state.respostas,
    DisplayNextGroup: state.displaynextgroup,
    DetailsAnotations: state.detailsanotations,
    ContactId: state.atendimento,
  };
};

const mapDispatchToProps = (dispatch) => ({
  ShowVisibleDetailsAtdIns: (post) => {
    dispatch(ShowVisibleDetailsAtd(post));
  },
  ByeMonitoring: (post, monitoringsimult) => {
    dispatch(CloseMonitoring(post, monitoringsimult));
  },
  InsertAnotationsIn: (idcdr, criticidade, comentario, userid) => {
    InsertAnotations(idcdr, criticidade, comentario, userid)(dispatch);
  },
  ProximoMonitoring: (proximoatd) => {
    SendNextMonitoring(proximoatd)(dispatch);
  },
  byeclientmonitoring: (cdrid) => {
    dispatch(ByeClientMonitoring(cdrid));
  },
  changeDisplayByeChat: (cdrid, serverid, iduser, infouser) => {
    changeDisplayByeChat(cdrid, serverid, iduser, infouser);
  },
  ChangeMonitoringUser: (monitoring) => {
    dispatch(
      addMonitoring(
        monitoring.userout,
        monitoring.agent,
        monitoring.line,
        monitoring.ramal
      )
    );
  },
  EditTypeMonitoring: (userin, userout, line, ramal) => {
    dispatch(EditTypeMonitorings(userout, line));
    dispatch(EditTypeMonitoringm(userout, line));
    InitialMonitoring(userin, userout, line, ramal);
  },
  InitialMonitoring: (userin, userout, name, line, ramal) => {
    dispatch(addMonitoring(userout, name, line, ramal));
    dispatch(addMonitoringSimult(userout, name, line, ramal));
    if (line != "4") {
      const socket = InitialMonitoring(userin, userout, line, ramal);
    } else {
      const socket = SharedScreen(ramal);
    }
  },
  RespostasRapidasida: (userid) => {
    RespostasRapidasida(userid)(dispatch);
  },
  DetailsAnotationsida: (datainit, datafim, idcriticidade, telefone) => {
    dispatch(DetailsAnotationsida(datainit, datafim, idcriticidade, telefone));
  },
  sendtyping: (typing, InfoUsers, ContactId) => {
    if (digitando === 0) {
      sendtypinwebsocket(1, InfoUsers, ContactId);
      digitando = 1;
      clearTimeout(typingTimer);
      typingTimer = setTimeout(doneTyping, doneTypingInterval);
    } else {
      doneTypingInterval = 5000;
    }

    function doneTyping() {
      digitando = 0;
      sendtypinwebsocket(0, InfoUsers, ContactId);
    }
  },
  sendFileAswSocket: (InfoUsers, ContactId, path, texto, makeid, line) => {
    if (path != "") {
      senfFileQuickAswMonitoring(
        InfoUsers,
        ContactId,
        path,
        texto,
        makeid,
        line
      );
    }
  },
  UploadFile: (data, InfoUsers, ContactId, caption, makeid, size, line) => {
    dispatch(
      InsertUploadMonitoring(
        data,
        InfoUsers,
        ContactId,
        caption,
        makeid,
        size,
        line
      )
    );
  },
  InviteMessage: (
    makeid,
    message,
    author,
    infousers,
    contactid,
    typemsg,
    msgsocket,
    line
  ) => {
    let time = Moment().format("HH:mm");
    let dia = Moment().format("DD");
    let mes = Moment().format("MM");
    mes = meses.indexOf(mes);
    dia = dia + " de " + meses[mes - 1];
    if (message != "") {
      dispatch(
        addMessage(
          makeid,
          message,
          author,
          time,
          contactid.idatendimento,
          typemsg,
          "entregue",
          false,
          dia
        ),
        InviteMessagesMonitoring(
          infousers,
          contactid,
          msgsocket,
          author,
          makeid,
          line
        )
      );
    }
  },
  sendImageAsw: (makeid, message, author, infousers, contactid, typemsg) => {
    let time = Moment().format("HH:mm");
    let dia = Moment().format("DD");
    let mes = Moment().format("MM");
    mes = meses.indexOf(mes);
    dia = dia + " de " + meses[mes - 1];
    if (message != "") {
      dispatch(
        addMessage(
          makeid,
          message,
          author,
          time,
          contactid.idatendimento,
          typemsg,
          "entregue",
          false,
          dia
        )
      );
    }
  },
});

class Monitorias extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileasw: [],
      searchText: "",
      typing: [],
      DescAnotacoes: [],
      respostas: [],
      respostasinicial: [],
      criticidadeSelec: "",
      iconeCriticidade: "",
      idCriticidadeSelec: 0,
      activeconsulta: false,
      showbuttondetails: " active",
      SaveSucess2: false,
      scroller: 0,
      usermonitors: [],
      clientmonitoring: 0,
      usermonitorsslider: [],
      moreClient: [],
      arraygeral: [],
      critSelec: "Todos",
      iconCrit: "",
      idCrit: "",
      buttonShowCriticits: false,
      detailsAnotations: [],
      totalAnotations: 0,
      buttonLearnMore: false,
      expandLearn: [],
      theaterStart: 20,
      arrayusermon: [],
    };
    this.scrollDown = this.scrollDown.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleselectedFile = this.handleselectedFile.bind(this);
  }

  componentDidMount() {
    this.props.RespostasRapidasida(this.props.InfoUsers.id);
    // tns({
    //   "container": "#monitoria-base",
    //   "items": 4,
    //   "edgePadding": 30,
    //   "loop": false,
    //   "mouseDrag": false,
    //   "swipeAngle": false,
    //   "nav": false,
    //   "speed": 200,
    //   "autoWidth": false,
    //   "controlsText": ['<i className="material-icons">keyboard_arrow_left</i>', '<i className="material-icons">keyboard_arrow_right</i>'],
    // });
  }

  renderPopoverPhoto = (e, ip, file) => (
    <>
      {file ? (
        <div className="img">
          <img
            src={
              file ? connection_platform.type_connect + "://" + ip + file : null
            }
            width="100"
            alt=""
          />
        </div>
      ) : (
        ""
      )}
    </>
  );

  componentDidUpdate(prevProps, prevState) {
    this.scrollDown();
    let lengthDiv = document.getElementById("chat-wrapper").offsetWidth;
    this.state.theaterStart = Math.trunc(lengthDiv / 210);
    this.state.theaterStart = this.state.theaterStart - 1;
  }

  DisplayQuickAnswer(e) {
    e.preventDefault();
    this.setState({ buttonQuickAnswer: !this.state.buttonQuickAnswer });
    const { RespostasRapidas } = this.props;
    this.state.respostasinicial = RespostasRapidas.respostas;
    this.state.respostas = this.state.respostasinicial;
  }

  handleClick() {
    this.setState((state) => ({
      activeconsulta: !state.activeconsulta,
      searchText: "",
      expand_less_count: 0,
      expand_more_count: 0,
    }));
    document.getElementById("simulation_click").click();
  }

  furtClient(e, infouser, cdrid, iduser) {
    const socket = sendFurtClient(infouser, cdrid, iduser);
    this.props.byeclientmonitoring(cdrid);
  }

  handleKeyUp(inf) {
    var elems = document.getElementsByTagName("mark");
    var tam = elems.length;

    if (tam >= this.state.arrowterm + 1) {
      elems[this.state.arrowterm].scrollIntoView(false);
      if (inf == "less") {
        if (this.state.arrowterm != 0) {
          this.state.arrowterm = this.state.arrowterm - 1;
        }
      } else {
        this.state.arrowterm = this.state.arrowterm + 1;
      }
    } else {
      if (elems[this.state.arrowterm]) {
        this.state.arrowterm = 0;
        elems[this.state.arrowterm].scrollIntoView(false);
      }
    }
  }

  handleselectedFile(event, infousers, contactid, line) {
    let filesend = event.target.files[0];
    if (filesend != undefined) {
      this.setState({
        selectedFile: filesend,
        loaded: 0,
      });
      let data = new FormData();
      let namefile = filesend.name;
      let hora = Moment().format("HH-mm-ss");
      let random = Math.floor(Math.random() * 999999 + 100000);
      random = random + "_" + hora;
      let ext = namefile.split(".").pop();
      namefile = random + "." + ext;
      data.append("file", filesend, namefile);
      let msgweb = document.getElementById("chat-message").innerText;
      let msgsocket = document.getElementById("chat-message").innerText;
      let str = msgsocket.replace(/\s/g, "");
      if (str != "") {
        msgweb = msgweb.trim();
        msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
        msgsocket = msgsocket.trim();
        msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
        document.getElementById("chat-message").innerHTML = "";
        this.props.UploadFile(
          data,
          infousers,
          contactid,
          msgweb,
          makeid(32),
          filesend.size,
          line
        );
      } else {
        this.props.UploadFile(
          data,
          infousers,
          contactid,
          "",
          makeid(32),
          filesend.size,
          line
        );
      }
    }
    document.getElementById("file-input").value = "";
  }

  DisplayAnotations(e) {
    e.preventDefault();
    this.setState({ buttonAnotations: !this.state.buttonAnotations });
  }

  handleKeyUp(inf) {
    var elems = document.getElementsByTagName("mark");
    var tam = elems.length;

    if (tam >= this.state.arrowterm + 1) {
      elems[this.state.arrowterm].scrollIntoView(false);
      if (inf == "less") {
        if (this.state.arrowterm != 0) {
          this.state.arrowterm = this.state.arrowterm - 1;
          if (this.state.expand_less_count != 1)
            this.setState({
              expand_less_count: this.state.expand_less_count - 1,
            });
        }
      } else {
        this.state.arrowterm = this.state.arrowterm + 1;
        if (this.state.expand_less_count != this.state.expand_more_count)
          this.setState({
            expand_less_count: this.state.expand_less_count + 1,
          });
      }
    } else {
      if (elems[this.state.arrowterm]) {
        this.state.arrowterm = 1;
        elems[this.state.arrowterm].scrollIntoView(false);
      }
    }
    if (tam === this.state.arrowterm) {
      if (inf == "less") {
        this.state.arrowterm = this.state.arrowterm - 1;
        this.setState({ expand_less_count: this.state.expand_less_count - 1 });
      }
    }
  }

  scrollDown() {
    const { containermon } = this.refs;
    if (this.state.scroller != containermon.scrollHeight) {
      containermon.scrollTop = containermon.scrollHeight;
      this.state.scroller = containermon.scrollHeight;
    }
    //document.getElementById('container').scrollTop = document.getElementById('container').scrollHeight
  }

  HandleDetails(e, visible) {
    e.preventDefault();
    this.props.ShowVisibleDetailsAtdIns(visible);
  }

  CloseMonitoringIn(e, simult, monitoring, monitoringsimult) {
    e.preventDefault();
    if (monitoringsimult.length > 1) {
      let j = 0;
      if (simult.userout === monitoringsimult[0].userout) {
        j = 1;
      }
      this.props.ProximoMonitoring(monitoringsimult[j]);
    }
    this.props.ByeMonitoring(simult, monitoringsimult);
    i = 0;
  }

  ChangeMonitoringClient(e, id, index) {
    this.setState({ clientmonitoring: id });
    i = index;
  }

  ChangeMonitoringUnique(e, id, arrayclient) {
    this.setState({ clientmonitoring: id });
    const auxindex = arrayclient.findIndex(
      (client, index, array) => client.idatendimento === id
    );
    i = auxindex;
  }

  ChangeMonitoringClientMore(e, id, arrayclient) {
    this.setState({ clientmonitoring: id, primaryid: id });
    const auxindex = arrayclient.findIndex(
      (client, index, array) => client.idatendimento === id
    );
    const filter = arrayclient.filter(
      (client, index, array) => client.idatendimento === id
    );

    this.setState({ clientmonitoring: id, arrayusermon: filter });
    i = auxindex;
    document.getElementById("simulation_click").click();
  }

  ChangeMonitoringUser(e, monitoring) {
    if (e.target.className === "card-atend") {
      this.props.ChangeMonitoringUser(monitoring);
      i = 0;
      this.setState({ primaryid: 0, arrayusermon: [] });
    }
  }

  GetTermText(event) {
    var elems = document.getElementsByTagName("mark");
    var tam = elems.length;
    this.setState({
      searchText: event.target.value,
      arrowterm: 0,
      expand_more_count: tam,
    });

    if (tam === 0) {
      this.setState({ expand_less_count: 0 });
    } else {
      this.setState({ expand_less_count: 1 });
    }
  }

  SaveAnotation2(e, infoatendimento, infouser) {
    var criticidade = this.state.idCriticidadeSelec;
    var comentario = this.comentarioAnotacoes.value;
    var erro = 0;
    var userid = infouser.id;
    var idcdr = this.state.idcdr;

    if (criticidade === "") var erro = 1;

    // if(comentario === '')
    //   var erro = 1

    if (userid === "") var erro = 1;

    if (idcdr === "") var erro = 1;

    if (erro === 0) {
      this.setState({ SaveSucess2: !this.state.SaveSucess2 });
      this.props.InsertAnotationsIn(idcdr, criticidade, comentario, userid);
      MicroModal.close("modal__anotacoes-adicionar");
      MicroModal.show("modal__anotacoes-salvo");
    }

    if (this.state.buttonShowCriticits === true)
      this.setState({ buttonShowCriticits: !this.state.buttonShowCriticits });
  }

  ReturnSaveSucess2() {
    document.getElementById("simulation_click").click();
    this.setState({ SaveSucess2: !this.state.SaveSucess2 });
  }

  DisplayCriticidade(desccriticidade, idcriticidade, tipocriticidade) {
    this.setState({
      criticidadeSelec: desccriticidade,
      iconeCriticidade: tipocriticidade,
      idCriticidadeSelec: idcriticidade,
    });
  }

  ClosePopovers(e) {
    document.getElementById("simulation_click").click();
  }

  ButtonSendMessage(event, author, InfoUsers, ContactId, typemsg, line) {
    event.preventDefault();
    document.getElementById("chat-message").disabled = false;
    let msgweb = document.getElementById("chat-message").innerText;
    let msgsocket = document.getElementById("chat-message").innerText;

    let infosendfile = this.state.fileasw;

    if (
      this.state.fileasw != null &&
      infosendfile[2] != 1 &&
      infosendfile.length > 0
    ) {
      msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
      msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
      let str = msgweb.replace(/\s/g, "");
      if (str != "") {
        this.props.sendFileAswSocket(
          InfoUsers,
          ContactId,
          infosendfile[0],
          msgweb,
          makeid(32),
          line
        );
        this.props.sendImageAsw(
          makeid(32),
          " ~¿" + msgweb + "~¿" + infosendfile[0],
          "Me",
          InfoUsers,
          ContactId,
          1
        );
      }
    } else {
      let str = msgweb.replace(/\s/g, "");
      if (str != "") {
        msgweb = msgweb.trim();
        msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
        msgsocket = msgsocket.trim();
        msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
        this.props.InviteMessage(
          makeid(32),
          msgweb,
          "Me",
          InfoUsers,
          ContactId,
          typemsg,
          msgsocket,
          line
        );
      }
    }
    this.scrollDown();
    document.getElementById("chat-message").innerHTML = "";
  }

  handleKeyDown = (event) => {
    var el = document.getElementById("chat-message");
    el.addEventListener("keypress", function (event) {
      if (event.keyCode == 13 && !event.shiftKey) {
        event.preventDefault();
        return false;
      }
    });
    el.addEventListener("keydown", function (event) {
      if (event.keyCode == 33) {
        event.preventDefault();
        return false;
      }
    });
  };

  handleKeyPress = (event) => {
    var el = document.getElementById("chat-message");
    el.addEventListener("keypress", function (event) {
      if (event.keyCode == 13 && !event.shiftKey) {
        event.preventDefault();
        return false;
      }
    });
    el.addEventListener("keydown", function (event) {
      if (event.keyCode == 33) {
        event.preventDefault();
        return false;
      }
    });
  };

  filterList(event, respostas) {
    var updatedList = respostas;
    updatedList = updatedList.filter(function (item) {
      let asw = item.qck_asw_keyword;
      let filtro = event.target.value;
      let er = /[^a-z0-9]/gi;
      filtro = filtro.replace(er, "");
      let resultado = asw.search(filtro);
      return asw.toLowerCase().search(filtro.toLowerCase()) != -1;
    });
    this.setState({ respostas: updatedList });
  }

  InsertQuickAnswer(
    event,
    texto,
    editable,
    mimetypeid,
    filepath,
    InfoUsers,
    ContactId
  ) {
    event.preventDefault();
    document.getElementById("chat-message").innerText = texto;
    if (mimetypeid != 1) {
      let gerarnomearquivo = makeid(32);
      let photo = {
        uri: filepath,
        type: "application/pdf",
        name: gerarnomearquivo + ".pdf",
      };
      let fileencryp = new FormData();
      fileencryp.append("file", gerarnomearquivo + ".pdf");
      //fileencryp.append('file', photo, gerarnomearquivo+".pdf");
      let arrayfile = [filepath, texto, mimetypeid];
      this.setState({ fileasw: [] });
      this.setState({ fileasw: arrayfile });
    } else {
      this.setState({ fileasw: [] });
      if (editable == false) {
        document.getElementById("chat-message").disabled = true;
      } else {
        document.getElementById("chat-message").disabled = false;
        document.getElementById("chat-message").focus();
      }
    }
    this.setState({ buttonQuickAnswer: !this.state.buttonQuickAnswer });
    document.getElementById("file-input").value = "";
  }

  handleOnChange(event, InfoUsers, ContactId, line) {
    if (event.key === "Enter" && event.shiftKey === false) {
      let teste = document.getElementsByClassName("chat-message");
      let msgweb = document.getElementById("chat-message").innerText;
      let msgsocket = document.getElementById("chat-message").innerText;
      let infosendfile = this.state.fileasw;

      if (
        this.state.fileasw != null &&
        infosendfile[2] != 1 &&
        infosendfile.length > 0
      ) {
        msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
        msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
        let str = msgweb.replace(/\s/g, "");
        if (str != "") {
          this.props.sendFileAswSocket(
            InfoUsers,
            ContactId,
            infosendfile[0],
            msgweb,
            makeid(32),
            line
          );
          this.props.sendImageAsw(
            makeid(32),
            " ~¿" + msgweb + "~¿" + infosendfile[0],
            "Me",
            InfoUsers,
            ContactId,
            1
          );
        }
        document.getElementById("chat-message").innerHTML = "";
        this.scrollDown();
        // this.props.sendtyping(0, InfoUsers, ContactId);NÃO MANDAR TYPPINY POR ENQUANTO
      } else {
        let str = msgweb.replace(/\s/g, "");
        if (str != "") {
          msgweb = msgweb.trim();
          msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
          msgsocket = msgsocket.trim();
          msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
          this.props.InviteMessage(
            makeid(32),
            msgweb,
            "Me",
            InfoUsers,
            ContactId,
            "0",
            msgsocket,
            line
          );
          document.getElementById("chat-message").innerHTML = "";
          this.scrollDown();
          // this.props.sendtyping(0, InfoUsers, ContactId);NÃO MANDAR TYPPINY POR ENQUANTO
        }
      }
    } else {
      // this.props.sendtyping(1, InfoUsers, ContactId);NÃO MANDAR TYPPINY POR ENQUANTO
    }
  }

  InitialMonitoring(e, userin, userout, name, monitoringsimult, line, ramal) {
    let erro = 0;
    let auxline;
    if (monitoringsimult.length != 0) {
      monitoringsimult.map((monitoring) => {
        if (parseInt(monitoring.userout) === parseInt(userout)) {
          erro = 1;
          auxline = monitoring.line;
        } else if (erro != 1) {
          erro = 0;
        }
      });
      if (erro === 1) {
        if (auxline != line) {
          this.props.EditTypeMonitoring(userin, userout, line, ramal);
          // this.props.InitialMonitoring(userin,userout,name,line,ramal)
        }
      } else {
        this.props.InitialMonitoring(userin, userout, name, line, ramal);
      }
    } else {
      this.props.InitialMonitoring(userin, userout, name, line, ramal);
    }
  }

  renderPopover = (e, clients, IPCurrent, usermon, Monitoring) => (
    <div className="context-menu context-menu--dark" id="drop-aba-more">
      <ul className="context-menu__list context-menu__list--more">
        {clients
          .filter((cli) => cli.idatendimento != this.state.primaryid)
          .map((client, index) => (
            <li
              key={index}
              onClick={(e) =>
                this.ChangeMonitoringClientMore(
                  e,
                  client.idatendimento,
                  this.state.arraygeral
                )
              }
              className={
                parseInt(client.idatendimento) === parseInt(Monitoring.cdrid)
                  ? "aba-more__item em-curso"
                  : "aba-more__item"
              }
              style={{
                display:
                  usermon.idatendimento === client.idatendimento
                    ? "none"
                    : "block",
              }}
            >
              <div className="aba-more__item__title">
                <div className="aba-more__item__title__photo">
                  {(() => {
                    if (client.pathfile === "  " || client.pathfile === " ") {
                      return <img src={DEFAULT} alt="" width="30" />;
                    } else {
                      return (
                        <img
                          src={
                            client.pathfile
                              ? connection_platform.type_connect +
                                "://" +
                                ipcurrent +
                                client.pathfile
                              : null
                          }
                          width="30"
                        />
                      );
                    }
                  })()}
                </div>
                <div className="aba-more__item__title__img">
                  {(() => {
                    if (client.idmidia === "5") {
                      return (
                        <img
                          src={WHATSAPPICON}
                          width="10"
                          alt=""
                          height="10"
                          className="user-name__channel-img"
                        />
                      );
                    } else if (client.idmidia === "6") {
                      return (
                        <img
                          src={FACEBOOKICON}
                          alt=""
                          width="10"
                          height="10"
                          className="user-name__channel-img"
                        />
                      );
                    } else if (client.idmidia === "2") {
                      return (
                        <img
                          src={WEBCHATICON}
                          alt=""
                          width="10"
                          height="10"
                          className="user-name__channel-img"
                        />
                      );
                    }
                  })()}
                </div>
                <div className="aba-more__item__title__text">
                  {createJSON(client.cliente)}
                </div>
              </div>
              <div className="aba-more__item__time">
                <div className="criticidade normal">•</div>
                <div className="aba-more__item__time__text">
                  {(() => {
                    var dataatual = Moment().format("YYYY/MM/DD HH:mm:ss");
                    var datatimeatd = Moment(
                      client.recuperationtime,
                      "DD/MM/YYYY HH:mm:ss"
                    ).format("YYYY/MM/DD HH:mm:ss");
                    var time = Moment(dataatual).diff(datatimeatd, "seconds");
                    time = parseInt(time) + Math.round(IPCurrent.difftime);
                    return (
                      <TimeCounterMinute
                        key={client.idatendimento}
                        horario={time}
                      />
                    );
                  })()}
                </div>
              </div>
            </li>
          ))}
      </ul>
    </div>
  );

  ViewAnotations(e, telefone, cliente, cdrid) {
    MicroModal.show("modal__anotacoes-adicionar");
    this.buttonSearchAnotation(e, telefone);
    this.setState({
      numbercliente: telefone,
      namecliente: cliente,
      idcdr: cdrid,
    });
  }

  ShowCriticitysInsert(e) {
    e.preventDefault();
    this.setState({ buttonShowCriticitsIn: !this.state.buttonShowCriticitsIn });
  }

  ChangeCriticitys(e, desccriticidade, idcriticidade, tipocriticidade) {
    e.preventDefault();
    this.setState({ buttonShowCriticitsIn: !this.state.buttonShowCriticitsIn });
    this.setState({
      criticidadeSelec: desccriticidade,
      iconeCriticidade: tipocriticidade,
      idCriticidadeSelec: idcriticidade,
    });
  }

  buttonSearchAnotation(e, telefone) {
    e.preventDefault();
    var erro = 0;
    const datainit = this.dataInit.value;
    const datafim = this.dataFim.value;
    const idcriticidade = this.state.idCrit;

    let comparation = Moment(datainit).isBefore(datafim);

    if (datainit == "") var erro = 1;

    if (datafim == "") var erro = 1;

    if (comparation === false) {
      var erro = 1;
      if (datainit === datafim) {
        var erro = 0;
      }
    }

    if (erro === 0) {
      this.props.DetailsAnotationsida(
        datainit,
        datafim,
        idcriticidade,
        telefone
      );
    }
  }

  ShowCriticitys(e) {
    e.preventDefault();
    this.setState({ buttonShowCriticits: !this.state.buttonShowCriticits });
  }

  SelectCriticitys(e, desccriticidade, idcriticidade, tipocriticidade) {
    this.setState({
      critSelec: desccriticidade,
      iconCrit: tipocriticidade,
      idCrit: idcriticidade,
    });
    this.setState({ buttonShowCriticits: !this.state.buttonShowCriticits });
  }

  checkExpandLearn(e, idanot) {
    var checkClick =
      this.state.expandLearn.indexOf(idanot) != -1 ? true : false;

    if (!checkClick) {
      this.setState({
        expandLearn: this.state.expandLearn.concat([idanot]),
      });
    } else {
      this.setState({
        expandLearn: this.state.expandLearn.filter(function (val) {
          return val != idanot;
        }),
      });
    }
  }

  changeDisplayTransfer(e, cdrid, serverid, usermon) {
    document.getElementById("transfer_teste").click();
    localStorage.setItem("idcdr", cdrid);
    localStorage.setItem("serverid", serverid);
    localStorage.setItem("usermon", usermon);
  }

  renderPopoverInfo = (
    e,
    number,
    cliente,
    cdrid,
    infouser,
    iduser,
    serverid,
    client
  ) => (
    <div className="context-menu" id="drop-aba-menu">
      <ul className="context-menu__list">
        <li
          className="contact-info contact-info--with-action"
          onClick={(event) =>
            this.changeDisplayTransfer(event, cdrid, serverid, iduser)
          }
        >
          <TRANSFERICON2 />
          <div className="contact-info__name">Transferir</div>
        </li>

        <li
          onClick={(event) =>
            this.ViewAnotations(event, number, cliente, cdrid)
          }
          className="contact-info contact-info--with-action"
        >
          <i className="material-icons">note_add</i>
          <div className="contact-info__name">Anotações</div>
        </li>

        <li
          onClick={this.handleClick}
          className="contact-info contact-info--with-action"
        >
          <i className="material-icons">search</i>
          <div className="contact-info__name">Pesquisar</div>
        </li>

        <li
          className="contact-info contact-info--with-action"
          onClick={(event) =>
            this.props.changeDisplayByeChat(cdrid, serverid, iduser, infouser)
          }
        >
          <ENCERRARATENDIMENTO />
          <div className="contact-info__name">Encerrar atendimento</div>
        </li>

        {/* <li onClick={event => this.furtClient(event,infouser,cdrid,iduser)} className="contact-info contact-info--with-action">    
          <i className="material-icons">phone</i> 
          <div className="contact-info__name">
            Atender
          </div>
        </li>    */}
      </ul>
    </div>
  );

  render() {
    const {
      Monitoring,
      MonitoringSimult,
      Typing,
      IPCurrent,
      Messages,
      InfoUsers,
      DisplayDetails,
      ClientUserMonitors,
      CriticidadesAnotacoes,
      RespostasRapidas,
      DisplayNextGroup,
      DetailsAnotations,
      ContactId,
    } = this.props;

    const { searchText } = this.state;
    const searchWords = searchText.split(/\s/).filter((word) => word);
    var typing_w = "";
    var dia = "";
    var auxdia = "";
    var monitorclient = [];
    var usermon = [];
    var loadingClient;

    if (DisplayDetails.displaydetailsatd === true)
      this.state.showbuttondetails = "";
    if (DisplayDetails.displaydetailsatd === false)
      this.state.showbuttondetails = " active";
    if (DisplayDetails.displaydetailsatd === undefined)
      this.state.showbuttondetails = "";

    if (Monitoring.length != 0 && ClientUserMonitors.length != 0) {
      this.state.arraygeral = ClientUserMonitors.filter(
        (client) => parseInt(Monitoring.userout) === parseInt(client.monuser)
      );
      this.state.usermonitors = this.state.arraygeral;
      monitorclient = this.state.usermonitors[i];
      // if(this.state.usermonitors.length != 0){
      this.state.usermonitors = this.state.usermonitors.slice(
        0,
        this.state.theaterStart
      );
      this.state.usermonitorsslider = this.state.arraygeral.slice(
        this.state.theaterStart,
        this.state.arraygeral.length
      );
      if (monitorclient)
        this.state.usermonitorsslider = this.state.usermonitorsslider.filter(
          (client) =>
            parseInt(usermon.idatendimento) != parseInt(client.idatendimento)
        );
      // }
    } else {
      monitorclient = [];
      this.state.usermonitors = [];
      this.state.usermonitorsslider = [];
      this.state.arraygeral = [];
    }

    if (monitorclient) {
      if (this.state.clientmonitoring === 0 && monitorclient.length != 0)
        this.state.clientmonitoring = monitorclient.idatendimento;
    }

    if (this.state.arrayusermon.length === 0) {
      this.state.usermonitors = this.state.arraygeral.slice(
        0,
        this.state.theaterStart + 1
      );
      this.state.usermonitorsslider = this.state.arraygeral.slice(
        this.state.theaterStart + 1,
        this.state.arraygeral.length
      );
      if (monitorclient)
        this.state.usermonitorsslider = this.state.usermonitorsslider.filter(
          (simult) => simult.idatendimento != monitorclient.idatendimento
        );
    }

    if (monitorclient) {
      var NovaMensagem = Messages[monitorclient.idatendimento];
      var Contador = [];

      if (NovaMensagem === undefined) {
        var NovaMensagem = [];
      }
    } else {
      var NovaMensagem = [];
    }

    if (Typing.length != 0) {
      this.state.typing = Typing;
    }

    this.state.typing.map((typingtodo) => {
      if (
        typingtodo.typing == "1" &&
        typingtodo.idatendimento == Monitoring.idatendimento
      ) {
        typing_w = (
          <div className="message left" style={{ marginTop: "20px" }}>
            <div className="bubble">
              <img src={LOADING} alt="" className="bubble__typing" width="48" />
            </div>
          </div>
        );
      }
    });

    if (DetailsAnotations.length != 0) {
      this.state.detailsAnotations = DetailsAnotations.detailsanotations;
      this.state.totalAnotations = this.state.detailsAnotations.length;
    } else {
      this.state.detailsAnotations = [];
      this.state.totalAnotations = 0;
    }

    if (CriticidadesAnotacoes.length != 0) {
      this.state.DescAnotacoes = CriticidadesAnotacoes.criticalitys;
      if (this.state.idCriticidadeSelec === 0) {
        this.state.iconeCriticidade =
          this.state.DescAnotacoes[0].class_criticality;
        this.state.criticidadeSelec = this.state.DescAnotacoes[0].description;
        this.state.idCriticidadeSelec = this.state.DescAnotacoes[0].id;
      }
    }

    this.datatimeinit = Moment().format("YYYY-MM-DD");
    this.datatimefim = Moment().format("YYYY-MM-DD");

    if (monitorclient === undefined) {
      monitorclient = this.state.usermonitors[0];
    }

    if (this.state.arrayusermon.length != 0)
      loadingClient = this.state.arraygeral.findIndex(
        (simult, index, array) =>
          simult.idatendimento === this.state.arrayusermon[0].idatendimento
      );
    if (loadingClient === -1) {
      this.state.arrayusermon = [];
      this.state.clientmonitoring = monitorclient.idatendimento;
    }

    return (
      <>
        <div id="app">
          <div className="stage">
            <div className="canvas monitorias-canvas" id="chat-wrapper">
              <div id="column2" className="chat-page column split column-chat">
                <div
                  className="popover-box block no-margin-bottom"
                  id="popover-all-notes"
                >
                  <div className="block-header">
                    <h1>
                      Anotações <i className="fas fa-exclamation-circle"></i>
                    </h1>
                    <div className="close">
                      <i className="far fa-times-circle"></i>
                    </div>
                  </div>
                  <div className="block-content">
                    <div className="column-user-details">
                      <div className="user-name">
                        André Luiz Batista Aureliano{" "}
                      </div>
                      <div className="user-time">
                        <i className="far fa-clock"></i>{" "}
                        <span className="time">00:10:12</span> na fila
                      </div>
                    </div>
                  </div>
                </div>
                <div className="chat-wrapper is-visible" style={{ zIndex: 1 }}>
                  <div className="atend-list">
                    <div className="monitoria-slider" id="monitoria-base">
                      {MonitoringSimult.map((simult, index) => (
                        <div
                          key={index}
                          className={
                            Monitoring.userout === simult.userout
                              ? "card-atend active"
                              : "card-atend"
                          }
                          onClick={(e) => this.ChangeMonitoringUser(e, simult)}
                        >
                          <div className="card-atend__title">
                            {simult.agent}
                          </div>
                          <div className="card-atend__actions">
                            <Tooltipp content={"Monitoria por voz"}>
                              <div
                                className={
                                  simult.line === "5"
                                    ? "card-atend__actions__item active"
                                    : "card-atend__actions__item"
                                }
                              >
                                <FALARATENDENTE />
                                {simult.line === "5" ? "Monitoria por Voz" : ""}
                              </div>
                            </Tooltipp>
                            <Tooltipp content={"Escuta sigilosa"}>
                              <div
                                onClick={(e) =>
                                  this.InitialMonitoring(
                                    e,
                                    InfoUsers.id,
                                    simult.userout,
                                    simult.agent,
                                    MonitoringSimult,
                                    "1",
                                    simult.ramal
                                  )
                                }
                                className={
                                  simult.line === "1"
                                    ? "card-atend__actions__item active"
                                    : "card-atend__actions__item"
                                }
                              >
                                <SIGILOSA />
                                {simult.line === "1" ? "Escuta sigilosa" : ""}
                              </div>
                            </Tooltipp>
                            <Tooltipp content={"Sussurro"}>
                              <div
                                onClick={(e) =>
                                  this.InitialMonitoring(
                                    e,
                                    InfoUsers.id,
                                    simult.userout,
                                    simult.agent,
                                    MonitoringSimult,
                                    "2",
                                    simult.ramal
                                  )
                                }
                                className={
                                  simult.line === "2"
                                    ? "card-atend__actions__item active"
                                    : "card-atend__actions__item"
                                }
                              >
                                <SUSURRO />
                                {simult.line === "2" ? "Sussurro" : ""}
                              </div>
                            </Tooltipp>

                            <Tooltipp content={"Intercalar"}>
                              <div
                                onClick={(e) =>
                                  this.InitialMonitoring(
                                    e,
                                    InfoUsers.id,
                                    simult.userout,
                                    simult.agent,
                                    MonitoringSimult,
                                    "3",
                                    simult.ramal
                                  )
                                }
                                className={
                                  simult.line === "3"
                                    ? "card-atend__actions__item active"
                                    : "card-atend__actions__item"
                                }
                              >
                                <INTERCALAR />
                                {simult.line === "3" ? "Intercalar" : ""}
                              </div>
                            </Tooltipp>

                            {/* <Tooltipp content={'Monitorar'}>
                            <div className={simult.line === '4' ? 'card-atend__actions__item active':'card-atend__actions__item'}>
                              <MONITORAR/>  
                              {simult.line === '4' ? 'Monitoria de tela':''}                     
                            </div>
                          </Tooltipp> */}
                            <div
                              className="card-atend__close-btn"
                              onClick={(e) =>
                                this.CloseMonitoringIn(
                                  e,
                                  simult,
                                  Monitoring,
                                  MonitoringSimult
                                )
                              }
                            >
                              <i className="material-icons">close</i>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {(() => {
                    if (
                      (Monitoring.line != "4" || Monitoring.line != "5") &&
                      this.state.usermonitors.length != 0
                    ) {
                      return (
                        <div className="aba-content">
                          <div className="aba-content__item">
                            <div className="client-aba">
                              {this.state.arrayusermon.map((usermon, index) => {
                                var nameClass = "client-aba__item";
                                if (
                                  usermon.idatendimento ===
                                  this.state.clientmonitoring
                                )
                                  nameClass = nameClass + " active";
                                if (
                                  parseInt(usermon.idatendimento) ===
                                  parseInt(Monitoring.cdrid)
                                )
                                  nameClass = nameClass + " em-curso";
                                return (
                                  <div
                                    key={index}
                                    className={nameClass}
                                    // onClick={(e) =>
                                    //   this.ChangeMonitoringUnique(
                                    //     e,
                                    //     usermon.idatendimento,
                                    //     this.state.arraygeral
                                    //   )
                                    // }
                                  >
                                    <Topover
                                      interactive={true}
                                      content={this.renderPopoverPhoto(
                                        this,
                                        ipcurrent,
                                        usermon.pathfile
                                      )}
                                    >
                                      <div className="client-aba__item__img">
                                        {(() => {
                                          if (
                                            usermon.pathfile === "  " ||
                                            usermon.pathfile === " "
                                          ) {
                                            // return <img src={DEFAULT} alt="" />;
                                            return <UserPhoto size="medium" />;
                                          } else {
                                            return (
                                              // <img
                                              //   src={
                                              //     usermon.pathfile
                                              //       ? connection_platform.type_connect +
                                              //         "://" +
                                              //         ipcurrent +
                                              //         usermon.pathfile
                                              //       : null
                                              //   }
                                              // />
                                              <UserPhoto
                                                size="medium"
                                                link={
                                                  usermon.pathfile
                                                    ? connection_platform.type_connect +
                                                      "://" +
                                                      ipcurrent +
                                                      usermon.pathfile
                                                    : null
                                                }
                                              />
                                            );
                                          }
                                        })()}
                                      </div>
                                    </Topover>
                                    <div
                                      className="client-aba__item__content"
                                      onClick={(e) =>
                                        this.ChangeMonitoringUnique(
                                          e,
                                          usermon.idatendimento,
                                          this.state.arraygeral
                                        )
                                      }
                                    >
                                      <div className="client-aba__item__title">
                                        <div className="client-aba__item__title__img">
                                          {(() => {
                                            if (usermon.idmidia === "5") {
                                              return (
                                                <img
                                                  src={WHATSAPPICON}
                                                  alt=""
                                                  className="user-name__channel-img"
                                                />
                                              );
                                            } else if (
                                              usermon.idmidia === "4"
                                            ) {
                                              return (
                                                <img
                                                  src={FACEBOOKICON}
                                                  alt=""
                                                  className="user-name__channel-img"
                                                />
                                              );
                                            } else if (
                                              usermon.idmidia === "2"
                                            ) {
                                              return (
                                                <img
                                                  src={WEBCHATICON}
                                                  alt=""
                                                  className="user-name__channel-img"
                                                />
                                              );
                                            } else if (
                                              usermon.idmidia === "3"
                                            ) {
                                              return (
                                                <img
                                                  src={MIDIAEMAIL}
                                                  alt=""
                                                  className="user-name__channel-img"
                                                />
                                              );
                                            } else if (
                                              usermon.idmidia === "8"
                                            ) {
                                              return (
                                                <img
                                                  src={MIDIATELEGRAM}
                                                  alt=""
                                                  className="user-name__channel-img"
                                                />
                                              );
                                            } else if (
                                              usermon.idmidia === "6"
                                            ) {
                                              return (
                                                <img
                                                  src={INSTAGRAM}
                                                  alt=""
                                                  className="user-name__channel-img"
                                                />
                                              );
                                            } else if (
                                              usermon.idmidia === "9"
                                            ) {
                                              return (
                                                <img
                                                  src={TWITTER}
                                                  alt=""
                                                  className="user-name__channel-img"
                                                />
                                              );
                                            } else if (
                                              usermon.idmidia === "10"
                                            ) {
                                              return (
                                                <img
                                                  src={LINKEDIN}
                                                  alt=""
                                                  className="user-name__channel-img"
                                                />
                                              );
                                            } else if (
                                              usermon.idmidia === "11"
                                            ) {
                                              return (
                                                <img
                                                  src={GOOGLEGBM}
                                                  alt=""
                                                  className="user-name__channel-img"
                                                />
                                              );
                                            } else if (
                                              usermon.idmidia === "15"
                                            ) {
                                              return (
                                                <img
                                                  src={TEAMS}
                                                  alt=""
                                                  className="user-name__channel-img"
                                                />
                                              );
                                            }
                                          })()}
                                        </div>
                                        <div className="client-aba__item__title__text">
                                          {createJSON(usermon.cliente)}
                                        </div>
                                      </div>
                                      <div className="client-aba__item__time">
                                        <span className="client-aba__item__time__critic">
                                          <div className="criticidade normal">
                                            •
                                          </div>
                                        </span>
                                        <div className="client-aba__item__time__text">
                                          {(() => {
                                            var dataatual = Moment().format(
                                              "YYYY/MM/DD HH:mm:ss"
                                            );
                                            var datatimeatd = Moment(
                                              usermon.recuperationtime,
                                              "DD/MM/YYYY HH:mm:ss"
                                            ).format("YYYY/MM/DD HH:mm:ss");
                                            var time = Moment(dataatual).diff(
                                              datatimeatd,
                                              "seconds"
                                            );
                                            time =
                                              parseInt(time) +
                                              Math.round(IPCurrent.difftime);
                                            return (
                                              <TimeCounterMinute
                                                key={usermon.idatendimento}
                                                horario={time}
                                              />
                                            );
                                          })()}
                                        </div>
                                        <img
                                          className="client-aba__item__time__typing"
                                          src={"build/images/typing.gif"}
                                          alt=""
                                        />
                                      </div>
                                    </div>
                                    <div
                                      className="client-aba__item__menu tippy-context-menu"
                                      data-tippy-placement="bottom"
                                      data-template="drop-consultar-encaminhar"
                                    >
                                      <Popover
                                        trigger="click"
                                        interactive={true}
                                        content={this.renderPopoverInfo(
                                          this,
                                          usermon.telefone,
                                          usermon.cliente,
                                          usermon.idatendimento,
                                          InfoUsers,
                                          usermon.monuser,
                                          usermon.serverid,
                                          usermon
                                        )}
                                      >
                                        <i className="material-icons">
                                          more_vert
                                        </i>
                                      </Popover>
                                    </div>

                                    <div className="client-aba__item__details">
                                      {(() => {
                                        let MenuBot =
                                          usermon.menubot.split("~¿");
                                        var verifierName =
                                          MenuBot[0].split(":");
                                        if (
                                          verifierName[0] === "Nome" ||
                                          verifierName[0] === "NOME"
                                        ) {
                                          MenuBot.shift();
                                        }
                                        return MenuBot.map((bot) => (
                                          <div className="client-aba__item__details__items">
                                            {createJSON(bot)}
                                          </div>
                                        ));
                                      })()}
                                    </div>
                                  </div>
                                );
                              })}

                              {this.state.usermonitors.map((client, index) => {
                                var nameClass = "client-aba__item";
                                if (
                                  client.idatendimento ===
                                  this.state.clientmonitoring
                                )
                                  nameClass = nameClass + " active";

                                if (
                                  parseInt(client.idatendimento) ===
                                  parseInt(Monitoring.cdrid)
                                )
                                  nameClass = nameClass + " em-curso";

                                return (
                                  <div
                                    key={index}
                                    className={nameClass}
                                    style={{
                                      display:
                                        usermon.idatendimento ===
                                        client.idatendimento
                                          ? "none"
                                          : "flex",
                                    }}
                                  >
                                    <Topover
                                      interactive={true}
                                      content={this.renderPopoverPhoto(
                                        this,
                                        ipcurrent,
                                        client.pathfile
                                      )}
                                    >
                                      <div className="client-aba__item__img">
                                        {(() => {
                                          if (
                                            client.pathfile === "  " ||
                                            client.pathfile === " "
                                          ) {
                                            // return <img src={DEFAULT} alt="" />;
                                            return <UserPhoto size="medium" />;
                                          } else {
                                            return (
                                              // <img
                                              //   src={
                                              //     client.pathfile
                                              //       ? connection_platform.type_connect +
                                              //         "://" +
                                              //         ipcurrent +
                                              //         client.pathfile
                                              //       : null
                                              //   }
                                              // />
                                              <UserPhoto
                                                size="medium"
                                                link={
                                                  client.pathfile
                                                    ? connection_platform.type_connect +
                                                      "://" +
                                                      ipcurrent +
                                                      client.pathfile
                                                    : null
                                                }
                                              />
                                            );
                                          }
                                        })()}
                                      </div>
                                    </Topover>
                                    <div
                                      className="client-aba__item__content"
                                      onClick={(e) =>
                                        this.ChangeMonitoringClient(
                                          e,
                                          client.idatendimento,
                                          index
                                        )
                                      }
                                    >
                                      <div className="client-aba__item__title">
                                        <div className="client-aba__item__title__img">
                                          {(() => {
                                            if (client.idmidia === "5") {
                                              return (
                                                <img
                                                  width="19"
                                                  height="19"
                                                  src={WHATSAPPICON}
                                                  alt=""
                                                  className="user-name__channel-img"
                                                />
                                              );
                                            } else if (client.idmidia === "4") {
                                              return (
                                                <img
                                                  width="19"
                                                  height="19"
                                                  src={FACEBOOKICON}
                                                  alt=""
                                                  className="user-name__channel-img"
                                                />
                                              );
                                            } else if (client.idmidia === "2") {
                                              return (
                                                <img
                                                  width="19"
                                                  height="19"
                                                  src={WEBCHATICON}
                                                  alt=""
                                                  className="user-name__channel-img"
                                                />
                                              );
                                            } else if (client.idmidia === "3") {
                                              return (
                                                <img
                                                  width="19"
                                                  height="19"
                                                  src={MIDIAEMAIL}
                                                  alt=""
                                                  className="user-name__channel-img"
                                                />
                                              );
                                            } else if (client.idmidia === "8") {
                                              return (
                                                <img
                                                  width="19"
                                                  height="19"
                                                  src={MIDIATELEGRAM}
                                                  alt=""
                                                  className="user-name__channel-img"
                                                />
                                              );
                                            } else if (client.idmidia === "6") {
                                              return (
                                                <img
                                                  width="19"
                                                  height="19"
                                                  src={INSTAGRAM}
                                                  alt=""
                                                  className="user-name__channel-img"
                                                />
                                              );
                                            } else if (client.idmidia === "9") {
                                              return (
                                                <img
                                                  width="19"
                                                  height="19"
                                                  src={TWITTER}
                                                  alt=""
                                                  className="user-name__channel-img"
                                                />
                                              );
                                            } else if (
                                              client.idmidia === "10"
                                            ) {
                                              return (
                                                <img
                                                  width="19"
                                                  height="19"
                                                  src={LINKEDIN}
                                                  alt=""
                                                  className="user-name__channel-img"
                                                />
                                              );
                                            } else if (
                                              client.idmidia === "11"
                                            ) {
                                              return (
                                                <img
                                                  width="19"
                                                  height="19"
                                                  src={GOOGLEGBM}
                                                  alt=""
                                                  className="user-name__channel-img"
                                                />
                                              );
                                            } else if (
                                              client.idmidia === "15"
                                            ) {
                                              return (
                                                <img
                                                  width="19"
                                                  height="19"
                                                  src={TEAMS}
                                                  alt=""
                                                  className="user-name__channel-img"
                                                />
                                              );
                                            }
                                          })()}
                                        </div>
                                        <div
                                          className="client-aba__item__title__text"
                                          onClick={(e) =>
                                            this.ChangeMonitoringClient(
                                              e,
                                              client.idatendimento,
                                              index
                                            )
                                          }
                                        >
                                          {createJSON(client.cliente)}
                                        </div>
                                      </div>
                                      <div className="client-aba__item__time">
                                        <span className="client-aba__item__time__critic">
                                          <div className="criticidade normal">
                                            •
                                          </div>
                                        </span>
                                        <div className="client-aba__item__time__text">
                                          {(() => {
                                            var dataatual = Moment().format(
                                              "YYYY/MM/DD HH:mm:ss"
                                            );
                                            var datatimeatd = Moment(
                                              client.recuperationtime,
                                              "DD/MM/YYYY HH:mm:ss"
                                            ).format("YYYY/MM/DD HH:mm:ss");
                                            var time = Moment(dataatual).diff(
                                              datatimeatd,
                                              "seconds"
                                            );
                                            time =
                                              parseInt(time) +
                                              Math.round(IPCurrent.difftime);
                                            return (
                                              <TimeCounterMinute
                                                key={client.idatendimento}
                                                horario={time}
                                              />
                                            );
                                          })()}
                                        </div>
                                        <img
                                          className="client-aba__item__time__typing"
                                          src={"build/images/typing.gif"}
                                          alt=""
                                        />
                                      </div>
                                    </div>
                                    <div
                                      className="client-aba__item__menu tippy-context-menu"
                                      data-tippy-placement="bottom"
                                      data-template="drop-consultar-encaminhar"
                                    >
                                      <Popover
                                        trigger="click"
                                        interactive={true}
                                        content={this.renderPopoverInfo(
                                          this,
                                          client.telefone,
                                          client.cliente,
                                          client.idatendimento,
                                          InfoUsers,
                                          client.monuser,
                                          client.serverid,
                                          client
                                        )}
                                      >
                                        <i className="material-icons">
                                          more_vert
                                        </i>
                                      </Popover>
                                    </div>
                                    <div className="client-aba__item__details">
                                      {(() => {
                                        let MenuBot =
                                          client.menubot.split("~¿");
                                        var verifierName =
                                          MenuBot[0].split(":");
                                        if (
                                          verifierName[0] === "Nome" ||
                                          verifierName[0] === "NOME"
                                        ) {
                                          MenuBot.shift();
                                        }
                                        return MenuBot.map((bot) => (
                                          <div className="client-aba__item__details__items">
                                            {createJSON(bot)}
                                          </div>
                                        ));
                                      })()}
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>

                          {(() => {
                            if (this.state.usermonitorsslider.length != 0) {
                              return (
                                <Popover
                                  trigger="click"
                                  interactive={true}
                                  content={this.renderPopover(
                                    this,
                                    this.state.usermonitorsslider,
                                    IPCurrent,
                                    usermon,
                                    Monitoring
                                  )}
                                >
                                  <div
                                    className="aba-content__more tippy-context-menu tippy active"
                                    data-tippy-placement="bottom"
                                    data-template="drop-aba-more"
                                  >
                                    <i className="material-icons">list</i>
                                  </div>
                                </Popover>
                              );
                            }
                          })()}
                        </div>
                      );
                    }
                  })()}
                  {(() => {
                    if (Monitoring.line === "4") {
                      return (
                        <div className="stream">
                          <div className="stream__box"></div>
                          <div className="stream__action">
                            <div className="stream__action__bt">
                              <i className="material-icons">zoom_out_map</i>
                            </div>
                          </div>
                          <div id="containermon" ref="containermon"></div>
                        </div>
                      );
                    } else if (
                      Monitoring.line === "5" &&
                      this.state.usermonitors.length != 0
                    ) {
                      return (
                        <div className="center">
                          <div className="center__item">
                            <div className="monitoria-voz">
                              <div className="monitoria-voz__wave-box">
                                <img src={SOUNDWAVE} />
                              </div>
                            </div>
                          </div>
                          <div id="containermon" ref="containermon"></div>
                        </div>
                      );
                    } else if (this.state.usermonitors.length != 0) {
                      return (
                        <div
                          className="block full-height no-margin-bottom"
                          id="chat"
                        >
                          <TransferClient
                            ClosePopovers={(event) => this.ClosePopovers()}
                            atdCurso={this.state.atdCurso}
                          />
                          <div className="block-header">
                            <div className="column-user-details">
                              {/* <div className="user-time">
                                              {
                                                (() => {
                                                    var dataatual = Moment().format('YYYY/MM/DD HH:mm:ss');
                                                    var datatimeatd = Moment(monitorclient.recuperationtime,'DD/MM/YYYY HH:mm:ss').format('YYYY/MM/DD HH:mm:ss');
                                                    var time = Moment(dataatual).diff(datatimeatd, 'seconds')
                                                    return <> <i className="far fa-clock"></i> <span className="time"><TimeCounter key={monitorclient.idatendimento} horario={time} /> </span></>
                                                })()
                                              }                 
                                            </div> */}
                            </div>
                            <div className="column-actions">
                              {(() => {
                                if (monitorclient.length != 0) {
                                  return (
                                    <a
                                      onClick={(event) =>
                                        this.HandleDetails(event, true)
                                      }
                                      className={
                                        "btn inline" +
                                        this.state.showbuttondetails
                                      }
                                      id="user-more-details"
                                    >
                                      {" Ver detalhes >"}
                                    </a>
                                  );
                                }
                              })()}
                            </div>
                            <div
                              className={
                                this.state.activeconsulta
                                  ? "block-header__search-box is-active"
                                  : "block-header__search-box"
                              }
                            >
                              <div className="block-header__search-box-nav">
                                <div className="block-header__search-box-content-input">
                                  <input
                                    type="text"
                                    autoFocus={true}
                                    onChange={(event) =>
                                      this.GetTermText(event)
                                    }
                                    placeholder="Pesquisar mensagens..."
                                    className="block-header__search-box-input"
                                  />

                                  <div className="block-header__search-box-content-count">
                                    {this.state.expand_less_count} de{" "}
                                    {this.state.expand_more_count}
                                  </div>
                                </div>

                                <div className="block-header__search-box-content-icon">
                                  <a
                                    onClick={(event) =>
                                      this.handleKeyUp("less")
                                    }
                                    className="block-header__search-box-icon material-icons"
                                  >
                                    expand_less
                                  </a>
                                  <a
                                    onClick={(event) =>
                                      this.handleKeyUp("more")
                                    }
                                    className="block-header__search-box-icon material-icons"
                                  >
                                    expand_more
                                  </a>
                                </div>
                                <button
                                  onClick={this.handleClick}
                                  className="block-header__search-box-button"
                                >
                                  Concluir
                                </button>
                              </div>
                            </div>
                          </div>
                          <div className="block-content chat-canvas">
                            <div
                              className="chat-canvas__content"
                              id="containermon"
                              ref="containermon"
                            >
                              {NovaMensagem.map((message, i) => {
                                if (message.dia != auxdia) {
                                  dia = message.dia;
                                  auxdia = message.dia;
                                } else {
                                  auxdia = message.dia;
                                  dia = "";
                                }
                                var positmessage1 = "message right";
                                var positmessage2 = "fav fav--right";

                                if (message.author != "Me") {
                                  var positmessage1 = "message left";
                                  var positmessage2 = "fav fav--left";
                                }

                                if (message.username === Monitoring.agent) {
                                  var positmessage1 = "message right";
                                  var positmessage2 = "fav fav--right";
                                }

                                if (message.author === "Gestor") {
                                  var positmessage1 = "message gestor";
                                  var positmessage2 = "fav fav--left";
                                }

                                var verifystar = this.state.active;
                                var mensagem_tratada = message.message.replace(
                                  /¿/gi,
                                  "\n"
                                );
                                if (message.typemsg === "2") {
                                  var mensagem_tratada =
                                    mensagem_tratada.replace(/§/gi, "\r\n");
                                }
                                if (
                                  message.author === "Me" &&
                                  parseInt(monitorclient.idatendimento) ===
                                    parseInt(message.contactid) &&
                                  message.typemsg === "0"
                                )
                                  return (
                                    <div key={i} className={positmessage1}>
                                      <div className="time">{dia}</div>
                                      <div className="bubble">
                                        <div
                                          className="text"
                                          style={{ whiteSpace: "pre-line" }}
                                        >
                                          <Highlighter
                                            highlightClassName="YourHighlightClass1"
                                            activeIndex="YourHighlightClass1"
                                            activeClassName="YourHighlightClass1"
                                            className="NovClass"
                                            searchWords={searchWords}
                                            textToHighlight={mensagem_tratada}
                                            sanitize={latinize}
                                          />
                                          <span className="text__end-spacing"></span>
                                        </div>
                                        <div className="bubble__info-content">
                                          <div
                                            className={
                                              message.favorite === "true"
                                                ? "fav fav--inside fav--right active"
                                                : "fav fav--inside fav--right"
                                            }
                                          >
                                            {/* <i onClick={event => this.markstar2(message.messageid, InfoUsers.id, message.favorite, Monitoring.idatendimento)} className="material-icons fav-icon">{message.favorite === 'true' ?  "star" : "star_border"}</i> */}
                                          </div>
                                          <div className="bubble__info-content__time">
                                            {message.datatime}
                                          </div>
                                          {(() => {
                                            if (
                                              positmessage1 != "message left"
                                            ) {
                                              if (
                                                message.statusmsg === "error" &&
                                                connection_platform.isStatusOfErrorInSendMessage
                                              )
                                                return (
                                                  <div
                                                    className={
                                                      "message-info message-info--" +
                                                      message.statusmsg
                                                    }
                                                  >
                                                    <i className="material-icons">
                                                      error
                                                    </i>
                                                  </div>
                                                );
                                              else if (
                                                message.statusmsg === "entregue"
                                              )
                                                return (
                                                  <div
                                                    className={"message-info"}
                                                  >
                                                    <i className="material-icons">
                                                      done_all
                                                    </i>
                                                  </div>
                                                );
                                              else if (
                                                message.statusmsg === "visto"
                                              )
                                                return (
                                                  <div
                                                    className={
                                                      "message-info message-info--visto"
                                                    }
                                                  >
                                                    <i className="material-icons">
                                                      done_all
                                                    </i>
                                                  </div>
                                                );
                                              else if (
                                                !connection_platform.isStatusOfErrorInSendMessage
                                              )
                                                return (
                                                  <div
                                                    className={"message-info"}
                                                  >
                                                    <i className="material-icons">
                                                      done_all
                                                    </i>
                                                  </div>
                                                );
                                              else
                                                return (
                                                  <div
                                                    className={"message-info"}
                                                  >
                                                    <i className="material-icons">
                                                      done
                                                    </i>
                                                  </div>
                                                );
                                            }
                                          })()}
                                        </div>
                                      </div>
                                    </div>
                                  );
                                else if (
                                  parseInt(monitorclient.idatendimento) ===
                                    parseInt(message.contactid) &&
                                  message.typemsg === "0"
                                )
                                  return (
                                    <div key={i} className={positmessage1}>
                                      <div className="time">{dia}</div>
                                      <div className="bubble">
                                        {(() => {
                                          if (
                                            positmessage1 === "message gestor"
                                          ) {
                                            return (
                                              <>
                                                <div className="bubble-user-name">
                                                  Gestor: {InfoUsers.username}
                                                </div>
                                                <div className="icon-gestor">
                                                  <GESTOR />
                                                  Gestor
                                                </div>
                                              </>
                                            );
                                          }
                                        })()}
                                        <div
                                          className="text"
                                          style={{ whiteSpace: "pre-line" }}
                                        >
                                          <Highlighter
                                            highlightClassName="YourHighlightClass"
                                            searchWords={searchWords}
                                            autoEscape={true}
                                            textToHighlight={mensagem_tratada}
                                            sanitize={latinize}
                                          />
                                          <span className="text__end-spacing"></span>
                                        </div>
                                        <div className="bubble__info-content">
                                          <div
                                            className={
                                              message.favorite === "true"
                                                ? "fav fav--inside fav--right active"
                                                : "fav fav--inside fav--right"
                                            }
                                          >
                                            {/* <i onClick={event => this.markstar2(message.messageid, InfoUsers.id, message.favorite, monitorclient.idatendimento)} className="material-icons fav-icon">{message.favorite === 'true' ?  "star" : "star_border"}</i> */}
                                          </div>
                                          <div className="bubble__info-content__time">
                                            {message.datatime}
                                          </div>
                                          {(() => {
                                            if (
                                              positmessage1 != "message left"
                                            ) {
                                              if (
                                                message.statusmsg === "error" &&
                                                connection_platform.isStatusOfErrorInSendMessage
                                              )
                                                return (
                                                  <div
                                                    className={
                                                      "message-info message-info--" +
                                                      message.statusmsg
                                                    }
                                                  >
                                                    <i className="material-icons">
                                                      error
                                                    </i>
                                                  </div>
                                                );
                                              else if (
                                                message.statusmsg === "entregue"
                                              )
                                                return (
                                                  <div
                                                    className={"message-info"}
                                                  >
                                                    <i className="material-icons">
                                                      done_all
                                                    </i>
                                                  </div>
                                                );
                                              else if (
                                                message.statusmsg === "visto"
                                              )
                                                return (
                                                  <div
                                                    className={
                                                      "message-info message-info--visto"
                                                    }
                                                  >
                                                    <i className="material-icons">
                                                      done_all
                                                    </i>
                                                  </div>
                                                );
                                              else if (
                                                !connection_platform.isStatusOfErrorInSendMessage
                                              )
                                                return (
                                                  <div
                                                    className={"message-info"}
                                                  >
                                                    <i className="material-icons">
                                                      done_all
                                                    </i>
                                                  </div>
                                                );
                                              else
                                                return (
                                                  <div
                                                    className={"message-info"}
                                                  >
                                                    <i className="material-icons">
                                                      done
                                                    </i>
                                                  </div>
                                                );
                                            }
                                          })()}
                                        </div>
                                      </div>
                                    </div>
                                  );
                                else if (
                                  parseInt(monitorclient.idatendimento) ===
                                    parseInt(message.contactid) &&
                                  message.typemsg === "2"
                                )
                                  return (
                                    <div key={i} className={positmessage1}>
                                      <div className="time">{dia}</div>
                                      <div className="bubble">
                                        <div
                                          className="text"
                                          style={{ whiteSpace: "pre-line" }}
                                        >
                                          <Highlighter
                                            highlightClassName="YourHighlightClass"
                                            searchWords={searchWords}
                                            autoEscape={true}
                                            textToHighlight={mensagem_tratada}
                                          />
                                          <span className="text__end-spacing"></span>
                                        </div>
                                        <div className="bubble__info-content">
                                          <div
                                            className={
                                              message.favorite === "true"
                                                ? "fav fav--inside fav--right active"
                                                : "fav fav--inside fav--right"
                                            }
                                            style={{ display: "none" }}
                                          >
                                            <i
                                              onClick={(event) =>
                                                this.markstar2(
                                                  message.messageid,
                                                  InfoUsers.id,
                                                  message.favorite,
                                                  Monitoring.idatendimento
                                                )
                                              }
                                              className="material-icons fav-icon"
                                            >
                                              {message.favorite === "true"
                                                ? "star"
                                                : "star_border"}
                                            </i>
                                          </div>
                                          <div className="bubble__info-content__time">
                                            {message.data}
                                          </div>
                                          {(() => {
                                            if (
                                              positmessage1 != "message left"
                                            ) {
                                              if (
                                                message.statusmsg === "error" &&
                                                connection_platform.isStatusOfErrorInSendMessage
                                              )
                                                return (
                                                  <div
                                                    className={
                                                      "message-info message-info--" +
                                                      message.statusmsg
                                                    }
                                                  >
                                                    <i className="material-icons">
                                                      error
                                                    </i>
                                                  </div>
                                                );
                                              else if (
                                                message.statusmsg === "entregue"
                                              )
                                                return (
                                                  <div
                                                    className={"message-info"}
                                                  >
                                                    <i className="material-icons">
                                                      done_all
                                                    </i>
                                                  </div>
                                                );
                                              else if (
                                                message.statusmsg === "visto"
                                              )
                                                return (
                                                  <div
                                                    className={
                                                      "message-info message-info--visto"
                                                    }
                                                  >
                                                    <i className="material-icons">
                                                      done_all
                                                    </i>
                                                  </div>
                                                );
                                              else if (
                                                !connection_platform.isStatusOfErrorInSendMessage
                                              )
                                                return (
                                                  <div
                                                    className={"message-info"}
                                                  >
                                                    <i className="material-icons">
                                                      done_all
                                                    </i>
                                                  </div>
                                                );
                                              else
                                                return (
                                                  <div
                                                    className={"message-info"}
                                                  >
                                                    <i className="material-icons">
                                                      done
                                                    </i>
                                                  </div>
                                                );
                                            }
                                          })()}
                                        </div>
                                      </div>
                                    </div>
                                  );
                                else if (
                                  parseInt(monitorclient.idatendimento) ===
                                    parseInt(message.contactid) &&
                                  message.typemsg === "1"
                                ) {
                                  var get_json = message.message;
                                  let separadorurlcaption =
                                    get_json.split("~¿");

                                  let thumbnail = separadorurlcaption[0];
                                  let caption = separadorurlcaption[1];
                                  let size = separadorurlcaption[3];
                                  if (caption)
                                    caption = caption.replace(/¿/gi, "\r\n");
                                  if (caption == "null") caption = "";

                                  let url = separadorurlcaption[2];
                                  let separador = url.split(".");
                                  let get_name = separador[0].split("/");
                                  let verificarexistencia = "";

                                  // eslint-disable-next-line default-case

                                  if (separador[1] !== undefined) {
                                    switch (separador[1].toLowerCase()) {
                                      case "jpeg":
                                      case "png":
                                      case "jpg":
                                        return (
                                          <div
                                            className={positmessage1}
                                            key={message.id}
                                          >
                                            <div className="time">{dia}</div>
                                            <div className="bubble">
                                              <div className="bubble-media">
                                                <div className="bubble-media__image">
                                                  <ModalImage
                                                    small={
                                                      connection_platform.type_connect +
                                                      "://" +
                                                      ipcurrent +
                                                      url
                                                    }
                                                    large={
                                                      connection_platform.type_connect +
                                                      "://" +
                                                      ipcurrent +
                                                      url
                                                    }
                                                    alt={get_name[6]}
                                                    hideDownload={true}
                                                    className="bubble-media__image-file"
                                                  />
                                                  {/* <img className="bubble-media__image-file" src={connection_platform.type_connect+'://'+ipcurrent+url} alt="" /> */}
                                                </div>
                                                <div className="bubble-media__mediaInfo">
                                                  <span className="bubble-media__fileType">
                                                    <img
                                                      className="bubble-media__fileIcon"
                                                      src={JPG}
                                                      alt=""
                                                    />
                                                  </span>
                                                  <span className="bubble-media__fileName">
                                                    <p className="bubble-media__text">
                                                      {get_name[6]}
                                                    </p>
                                                    <br />
                                                    <div className="fileinfo__bar">
                                                      <span className="fileinfo__size">
                                                        {size}
                                                      </span>{" "}
                                                      •{" "}
                                                      <span className="fileinfo__type">
                                                        {separador[1].toUpperCase()}
                                                      </span>
                                                    </div>
                                                  </span>

                                                  {(() => {
                                                    if (
                                                      InfoUsers.permdownload ===
                                                      true
                                                    ) {
                                                      return (
                                                        <div className="bubble-media__download">
                                                          <a
                                                            href={
                                                              connection_platform.type_connect +
                                                              "://" +
                                                              ipcurrent +
                                                              url
                                                            }
                                                            target="_blank"
                                                            download
                                                            className="bubble-media__btnDownload"
                                                          >
                                                            <i className="material-icons">
                                                              get_app
                                                            </i>
                                                          </a>
                                                        </div>
                                                      );
                                                    }
                                                  })()}
                                                </div>
                                              </div>
                                              <div className="text">
                                                {caption}
                                              </div>
                                              <div className="bubble__info-content">
                                                <div
                                                  className={
                                                    message.favorite === "true"
                                                      ? "fav fav--inside fav--right active"
                                                      : "fav fav--inside fav--right"
                                                  }
                                                >
                                                  {/* <i onClick={event => this.markstar2(message.messageid, InfoUsers.id, message.favorite, Monitoring.idatendimento)} className="material-icons fav-icon">{message.favorite === 'true' ?  "star" : "star_border"}</i> */}
                                                </div>
                                                <div className="bubble__info-content__time">
                                                  {message.datatime}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        );

                                        break;
                                      case "pdf":
                                        if (
                                          thumbnail === " " ||
                                          thumbnail === null ||
                                          thumbnail === "null"
                                        ) {
                                          verificarexistencia = "";
                                        } else {
                                          verificarexistencia = (
                                            <div className="bubble-media__image">
                                              <ModalImage
                                                small={
                                                  connection_platform.type_connect +
                                                  "://" +
                                                  ipcurrent +
                                                  thumbnail
                                                }
                                                large={
                                                  connection_platform.type_connect +
                                                  "://" +
                                                  ipcurrent +
                                                  thumbnail
                                                }
                                                alt={get_name[6]}
                                                hideDownload={true}
                                                className="bubble-media__image-file"
                                              />
                                            </div>
                                          );
                                        }

                                        return (
                                          <div
                                            className={positmessage1}
                                            key={message.id}
                                          >
                                            <div className="time">{dia}</div>
                                            <div className="bubble">
                                              <div className="bubble-media">
                                                {verificarexistencia}
                                                <div className="bubble-media__mediaInfo">
                                                  <span className="bubble-media__fileType">
                                                    <img
                                                      className="bubble-media__fileIcon"
                                                      src={PDF}
                                                      alt=""
                                                    />
                                                  </span>
                                                  <span className="bubble-media__fileName">
                                                    <p className="bubble-media__text">
                                                      {get_name[6]}
                                                    </p>
                                                    <br />
                                                    <div className="fileinfo__bar">
                                                      <span className="fileinfo__size">
                                                        {size}
                                                      </span>{" "}
                                                      •{" "}
                                                      <span className="fileinfo__type">
                                                        {separador[1].toUpperCase()}
                                                      </span>
                                                    </div>
                                                  </span>
                                                  {(() => {
                                                    if (
                                                      InfoUsers.permdownload ===
                                                      true
                                                    ) {
                                                      return (
                                                        <div className="bubble-media__download">
                                                          <a
                                                            href={
                                                              connection_platform.type_connect +
                                                              "://" +
                                                              ipcurrent +
                                                              url
                                                            }
                                                            target="_blank"
                                                            download
                                                            className="bubble-media__btnDownload"
                                                          >
                                                            <i className="material-icons">
                                                              get_app
                                                            </i>
                                                          </a>
                                                        </div>
                                                      );
                                                    }
                                                  })()}
                                                </div>
                                              </div>
                                              <div className="text">
                                                {caption}
                                              </div>
                                              <div className="bubble__info-content">
                                                <div
                                                  className={
                                                    message.favorite === "true"
                                                      ? "fav fav--inside fav--right active"
                                                      : "fav fav--inside fav--right"
                                                  }
                                                >
                                                  {/* <i onClick={event => this.markstar2(message.messageid, InfoUsers.id, message.favorite, monitorclient.idatendimento)} className="material-icons fav-icon">{message.favorite === 'true' ?  "star" : "star_border"}</i> */}
                                                </div>
                                                <div className="bubble__info-content__time">
                                                  {message.datatime}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        );
                                        break;
                                      case "xls":
                                      case "xlsx":
                                      case "doc":
                                      case "docx":
                                      case "ppt":
                                      case "pptx":
                                        return (
                                          <div
                                            className={positmessage1}
                                            key={message.id}
                                          >
                                            <div className="time">{dia}</div>
                                            <div className="bubble">
                                              <div className="bubble-media">
                                                <div className="bubble-media__mediaInfo">
                                                  <span className="bubble-media__fileType">
                                                    <img
                                                      className="bubble-media__image-file"
                                                      src={
                                                        connection_platform.type_connect +
                                                        "://" +
                                                        ipcurrent +
                                                        url
                                                      }
                                                      alt=""
                                                    />
                                                  </span>
                                                  <span className="bubble-media__fileName">
                                                    <p className="bubble-media__text">
                                                      {get_name[6]}
                                                    </p>
                                                    <br />
                                                    <div className="fileinfo__bar">
                                                      <span className="fileinfo__size">
                                                        {size}
                                                      </span>{" "}
                                                      •{" "}
                                                      <span className="fileinfo__type">
                                                        {separador[1].toUpperCase()}
                                                      </span>
                                                    </div>
                                                  </span>
                                                  {(() => {
                                                    if (
                                                      InfoUsers.permdownload ===
                                                      true
                                                    ) {
                                                      return (
                                                        <div className="bubble-media__download">
                                                          <a
                                                            href={
                                                              connection_platform.type_connect +
                                                              "://" +
                                                              ipcurrent +
                                                              url
                                                            }
                                                            target="_blank"
                                                            download
                                                            className="bubble-media__btnDownload"
                                                          >
                                                            <i className="material-icons">
                                                              get_app
                                                            </i>
                                                          </a>
                                                        </div>
                                                      );
                                                    }
                                                  })()}
                                                  <div className="bubble__info-content">
                                                    <div
                                                      className={
                                                        message.favorite ===
                                                        "true"
                                                          ? "fav fav--inside fav--right active"
                                                          : "fav fav--inside fav--right"
                                                      }
                                                    >
                                                      {/* <i onClick={event => this.markstar2(message.messageid, InfoUsers.id, message.favorite, monitorclient.idatendimento)} className="material-icons fav-icon">{message.favorite === 'true' ?  "star" : "star_border"}</i> */}
                                                    </div>
                                                    <div className="bubble__info-content__time">
                                                      {message.datatime}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        );
                                        break;
                                      case "wav":
                                      case "mp3":
                                      case "ogg":
                                      case "mpeg":
                                        return (
                                          <div
                                            className={positmessage1}
                                            key={message.id}
                                          >
                                            <div className="time">{dia}</div>
                                            <div className="bubble">
                                              <div className="bubble-media">
                                                <div className="bubble-media__playerBar">
                                                  <audio controls>
                                                    <source
                                                      src={
                                                        connection_platform.type_connect +
                                                        "://" +
                                                        ipcurrent +
                                                        url
                                                      }
                                                      type="audio/ogg"
                                                    />
                                                    <source
                                                      src={
                                                        connection_platform.type_connect +
                                                        "://" +
                                                        ipcurrent +
                                                        url
                                                      }
                                                      type="audio/mpeg"
                                                    />
                                                    Your browser.
                                                  </audio>
                                                </div>
                                                <div className="bubble-media__mediaInfo">
                                                  <span className="bubble-media__fileType">
                                                    <img
                                                      className="bubble-media__fileIcon"
                                                      src={MP3}
                                                      alt=""
                                                    />
                                                  </span>
                                                  <span className="bubble-media__fileName">
                                                    <p className="bubble-media__text">
                                                      {get_name[6]}
                                                    </p>
                                                    <br />
                                                    <div className="fileinfo__bar">
                                                      <span className="fileinfo__size">
                                                        {size}
                                                      </span>{" "}
                                                      •{" "}
                                                      <span className="fileinfo__type">
                                                        {separador[1].toUpperCase()}
                                                      </span>
                                                    </div>
                                                  </span>
                                                  {(() => {
                                                    if (
                                                      InfoUsers.permdownload ===
                                                      true
                                                    ) {
                                                      return (
                                                        <div className="bubble-media__download">
                                                          <a
                                                            href={
                                                              connection_platform.type_connect +
                                                              "://" +
                                                              ipcurrent +
                                                              url
                                                            }
                                                            target="_blank"
                                                            download
                                                            className="bubble-media__btnDownload"
                                                          >
                                                            <i className="material-icons">
                                                              get_app
                                                            </i>
                                                          </a>
                                                        </div>
                                                      );
                                                    }
                                                  })()}
                                                  <div className="bubble__info-content">
                                                    <div
                                                      className={
                                                        message.favorite ===
                                                        "true"
                                                          ? "fav fav--inside fav--right active"
                                                          : "fav fav--inside fav--right"
                                                      }
                                                    >
                                                      {/* <i onClick={event => this.markstar2(message.messageid, InfoUsers.id, message.favorite, monitorclient.idatendimento)} className="material-icons fav-icon">{message.favorite === 'true' ?  "star" : "star_border"}</i> */}
                                                    </div>
                                                    <div className="bubble__info-content__time">
                                                      {message.datatime}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        );
                                        break;
                                      case "mp4":
                                        return (
                                          <div
                                            className={positmessage1}
                                            key={message.id}
                                          >
                                            <div className="time">{dia}</div>
                                            <div className="bubble">
                                              <div className="bubble-media">
                                                <div className="bubble-media__video">
                                                  <video
                                                    className="bubble-media__video-frame"
                                                    controls
                                                  >
                                                    <source
                                                      className="bubble-media__video-file"
                                                      src={
                                                        connection_platform.type_connect +
                                                        "://" +
                                                        ipcurrent +
                                                        url
                                                      }
                                                      type="video/mp4"
                                                    />
                                                    Seu navegador nao suporta
                                                    esse tipo de arquivo.
                                                  </video>
                                                </div>
                                                <div className="bubble-media__mediaInfo">
                                                  <span className="bubble-media__fileType">
                                                    <img
                                                      className="bubble-media__fileIcon"
                                                      src={AVI}
                                                      alt=""
                                                    />
                                                  </span>
                                                  <span className="bubble-media__fileName">
                                                    <p className="bubble-media__text">
                                                      {get_name[6]}
                                                    </p>
                                                    <br />
                                                    <div className="fileinfo__bar">
                                                      <span className="fileinfo__size">
                                                        {size}
                                                      </span>{" "}
                                                      •{" "}
                                                      <span className="fileinfo__type">
                                                        {separador[1].toUpperCase()}
                                                      </span>
                                                    </div>
                                                  </span>
                                                  {(() => {
                                                    if (
                                                      InfoUsers.permdownload ===
                                                      true
                                                    ) {
                                                      return (
                                                        <div className="bubble-media__download">
                                                          <a
                                                            href={
                                                              connection_platform.type_connect +
                                                              "://" +
                                                              ipcurrent +
                                                              url
                                                            }
                                                            target="_blank"
                                                            download
                                                            className="bubble-media__btnDownload"
                                                          >
                                                            <i className="material-icons">
                                                              get_app
                                                            </i>
                                                          </a>
                                                        </div>
                                                      );
                                                    }
                                                  })()}
                                                </div>
                                              </div>
                                              <div className="text">
                                                {caption}
                                              </div>
                                              <div className="bubble__info-content">
                                                <div
                                                  className={
                                                    message.favorite === "true"
                                                      ? "fav fav--inside fav--right active"
                                                      : "fav fav--inside fav--right"
                                                  }
                                                >
                                                  {/* <i onClick={event => this.markstar2(message.messageid, InfoUsers.id, message.favorite, monitorclient.idatendimento)} className="material-icons fav-icon">{message.favorite === 'true' ?  "star" : "star_border"}</i> */}
                                                </div>
                                                <div className="bubble__info-content__time">
                                                  {message.datatime}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        );
                                        break;
                                    }
                                  }
                                }
                              })}
                              {typing_w}
                            </div>
                          </div>
                          <div
                            className="block-footer"
                            style={{
                              display:
                                Monitoring.line === "1" ? "none" : "block",
                            }}
                          >
                            <div className="message-box">
                              <div className="input-message">
                                {(() => {
                                  if (Monitoring.line === "2") {
                                    return (
                                      <div className="monitoria-icon">
                                        <SUSURRO />
                                      </div>
                                    );
                                  } else if (Monitoring.line === "3") {
                                    return (
                                      <div className="monitoria-icon">
                                        <INTERCALAR />
                                      </div>
                                    );
                                  }
                                })()}
                                <div
                                  onKeyPress={this.handleKeyPress}
                                  autoComplete="off"
                                  type="text"
                                  ref={(node) => (this.node = node)}
                                  onInput={(e) =>
                                    (valorInput = e.target.innerText)
                                  }
                                  onKeyDown={this.handleKeyDown}
                                  onKeyUp={(event) =>
                                    this.handleOnChange(
                                      event,
                                      InfoUsers,
                                      monitorclient,
                                      Monitoring.line
                                    )
                                  }
                                  className="chat-message"
                                  id="chat-message"
                                  contentEditable="true"
                                ></div>

                                <button
                                  type="submit"
                                  onClick={(event) =>
                                    this.ButtonSendMessage(
                                      event,
                                      "Me",
                                      InfoUsers,
                                      monitorclient,
                                      "0",
                                      Monitoring.line
                                    )
                                  }
                                  className="send-message"
                                >
                                  <i className="material-icons">send</i>
                                </button>
                              </div>
                              <a
                                onClick={this.DisplayQuickAnswer.bind(this)}
                                className="btn action with-icon"
                                id="action-premade-messages"
                                data-tippy="Mensagens predefinidas"
                              >
                                <i className="material-icons">
                                  chat_bubble_outline
                                </i>
                              </a>
                              <div
                                className={
                                  this.state.buttonQuickAnswer
                                    ? "premade-msg active"
                                    : "premade-msg"
                                }
                              >
                                <p className="premade-msg__title">
                                  Mensagens Predefinidas
                                </p>
                                <div className="premade-msg__content">
                                  <ul className="premade-msg__list">
                                    {this.state.respostas.map((resp) => (
                                      <li
                                        key={resp.qck_asw_id}
                                        className="premade-msg__item"
                                        onClick={(event) =>
                                          this.InsertQuickAnswer(
                                            event,
                                            resp.qck_asw_answer,
                                            resp.editable,
                                            resp.mimetypeid,
                                            resp.filepath,
                                            InfoUsers,
                                            monitorclient
                                          )
                                        }
                                      >
                                        {resp.qck_asw_keyword}
                                      </li>
                                    ))}
                                  </ul>
                                  <div className="premade-msg__input-wrapper">
                                    <input
                                      type="text"
                                      className="premade-msg__search-input"
                                      onChange={(event) =>
                                        this.filterList(
                                          event,
                                          this.state.respostasinicial
                                        )
                                      }
                                      placeholder="Pesquise uma resposta..."
                                    />
                                    <span className="premade-msg__input-icon">
                                      <i className="material-icons">search</i>
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <a
                                href="#"
                                className="btn action with-icon chat-special tippy-default"
                                data-tippy-theme="light"
                                id="action-attachment"
                                data-tippy-content="Adicionar Anexo"
                              >
                                <label
                                  htmlFor="file-input"
                                  className="material-icons"
                                >
                                  attach_file
                                </label>
                                <input
                                  style={{ display: "none" }}
                                  type="file"
                                  name="upload"
                                  id="file-input"
                                  onChange={(event) =>
                                    this.handleselectedFile(
                                      event,
                                      InfoUsers,
                                      monitorclient,
                                      Monitoring.line
                                    )
                                  }
                                />
                              </a>
                              <a
                                href="#"
                                className="btn action with-icon chat-special tippy-default"
                                data-tippy-theme="light"
                                id="action-voice"
                                data-tippy-content="Atender em voz"
                              >
                                <i className="material-icons">mic</i>
                              </a>

                              {/* <!-- PREMADE MESSAGES BOX --> */}
                              <div className="premade-msg">
                                <p className="premade-msg__title">
                                  Respostas rápidas
                                </p>
                                <div className="premade-msg__content">
                                  <ul className="premade-msg__list">
                                    <li className="premade-msg__item">
                                      Estou pesquisando. Por favor aguarde.
                                    </li>
                                    <li className="premade-msg__item">
                                      Um momento, por favor.
                                    </li>
                                    <li className="premade-msg__item">
                                      Já tenho o seu numero de protocolo. Pode
                                      anotar?
                                    </li>
                                    <li className="premade-msg__item">
                                      Um momento, por favor.
                                    </li>
                                  </ul>
                                  <div className="premade-msg__input-wrapper">
                                    <input
                                      type="text"
                                      className="premade-msg__search-input"
                                      placeholder="Pesquise uma resposta..."
                                    />
                                    <span className="premade-msg__input-icon">
                                      <i className="material-icons">search</i>
                                    </span>
                                  </div>
                                </div>
                                {/* <!-- END PREMADE MESSAGES BOX --> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    } else {
                      return (
                        <div
                          className="block full-height no-margin-bottom"
                          id="chat"
                        >
                          <div className="center">
                            <div className="center__item">
                              <div className="monitoria-futura">
                                <div className="monitoria-futura__text">
                                  <div className="monitoria-futura__text__title">
                                    Oops...
                                  </div>
                                  <div className="monitoria-futura__text__bodytext">
                                    <span className="monitoria-futura__text__bodytext__operator">
                                      {Monitoring.agent + " "}
                                    </span>
                                    não está em atendimento agora
                                  </div>
                                </div>
                                <img
                                  className="monitoria-futura__img"
                                  src={MONITORIAFUTURA}
                                />
                              </div>
                              <div id="containermon" ref="containermon"></div>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  })()}
                </div>
                <div
                  className="block transparent active-chats"
                  id="active-chats"
                >
                  <div className="active-chats__tabs">
                    <ul className="active-chats__list">
                      <ChatSimultComponent
                        chatemcurso={this.state.chat}
                        remotescreen={"monitorias"}
                      />
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            {/* Modal De Anotacoes */}

            <div
              className="modal micromodal-slide"
              id="modal__anotacoes-details"
              aria-hidden="true"
              role="dialog"
            >
              <div className="modal__overlay" tabIndex="-1">
                <div
                  className="modal__container"
                  role="dialog"
                  aria-modal="true"
                  aria-labelledby="modal__anotacoes__title"
                >
                  <header className="modal__header">
                    <h2 className="modal__title" id="modal__anotacoes__title">
                      Anotações
                    </h2>
                    <button
                      className="modal__close"
                      aria-label="Close modal"
                      data-micromodal-close
                    ></button>
                  </header>
                  <main
                    className="modal__content"
                    id="modal__anotacoes__content"
                  >
                    <div className="anotc__info">
                      <p className="anotc__name  is-poppins">
                        {createJSON(this.state.namecliente)}
                      </p>
                      <i className="material-icons anotc__icon">note</i>{" "}
                      <span className="anotc__info-text">
                        Total de{" "}
                        <span className="anotc__counter">
                          {this.state.totalAnotations}
                        </span>{" "}
                        anotações
                      </span>
                    </div>
                    <div className="anotc__wrapper">
                      <div className="anotc__mp">
                        <div className="anotc__mp-ctrL">
                          <div className="anotc__mp-date">
                            <p className="anotc__mp-date-text">
                              Deseja buscar as anotação de qual período?
                            </p>
                            <div className="anotc__mp-date-wrapper">
                              <span className="anotc__mp-date-span">De:</span>
                              <input
                                type="date"
                                className="anotc__mp-date-start"
                                defaultValue={this.datatimeinit}
                                ref={(input) => (this.dataInit = input)}
                              />
                              <span className="anotc__mp-date-span">Até:</span>
                              <input
                                type="date"
                                className="anotc__mp-date-end"
                                defaultValue={this.datatimefim}
                                ref={(input) => (this.dataFim = input)}
                              />
                            </div>
                          </div>
                          <div className="anotc__mp-critic">
                            <p className="anotc__mp-critic-text">
                              E com qual nível de criticidade?
                            </p>
                            <div className="anotc__mp-critic-wrapper">
                              <button
                                className="anotc__mp-critic-btn"
                                onClick={this.ShowCriticitys.bind(this)}
                              >
                                {this.state.critSelec}
                                <i className="anotc__mp-critic-icon material-icons">
                                  keyboard_arrow_down
                                </i>
                              </button>
                              <div
                                className={
                                  this.state.buttonShowCriticits
                                    ? "anotc__mp-critic-options active"
                                    : "anotc__mp-critic-options"
                                }
                              >
                                <ul className="anotc__mp-critic-list">
                                  <li
                                    className="anotc__mp-critic-item"
                                    onClick={this.SelectCriticitys.bind(
                                      this,
                                      "",
                                      "Todos",
                                      ""
                                    )}
                                  >
                                    <span className="anotc__mp-critic-dot">
                                      •
                                    </span>
                                    Todos
                                  </li>
                                  {this.state.DescAnotacoes.map((desc) => (
                                    <li
                                      key={desc.id}
                                      className="anotc__mp-critic-item"
                                      onClick={this.SelectCriticitys.bind(
                                        this,
                                        desc.class_criticality,
                                        desc.description,
                                        desc.id
                                      )}
                                    >
                                      <span
                                        className={
                                          "anotc__mp-critic-dot " +
                                          desc.class_criticality
                                        }
                                      >
                                        •
                                      </span>
                                      {desc.description}
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            </div>
                          </div>
                          <button
                            className="anotc__mp-btn"
                            onClick={(event) =>
                              this.buttonSearchAnotation(
                                event,
                                this.state.numbercliente
                              )
                            }
                          >
                            Filtrar
                          </button>
                        </div>

                        <div className="anotc__mp-result">
                          <div className="anotc__mp-search">
                            <span className="material-icons anotc__mp-search-icon">
                              expand_less
                            </span>
                            <span className="material-icons anotc__mp-search-icon">
                              expand_more
                            </span>
                            <input
                              type="text"
                              className="anotc__mp-search-input"
                              placeholder="Pesquisar..."
                            />
                            <button className="anotc__mp-search-btn">
                              Concluir
                            </button>
                          </div>

                          <ul className="anotc__mp-result-list">
                            {this.state.detailsAnotations.map((details) => (
                              <li
                                key={details.id}
                                className="anotc__mp-result-item"
                              >
                                <button className="anotc__mp-result-avatar">
                                  <img src="build/images/cliente.svg" alt="" />
                                </button>
                                <a
                                  href="#"
                                  className="anotc__mp-result-btn"
                                  onClick={(event) =>
                                    this.checkExpandLearn(event, details.id)
                                  }
                                >
                                  <span className="anotc__mp-result-span material-icons">
                                    {this.state.buttonLearnMore ||
                                    this.state.expandLearn.indexOf(
                                      details.id
                                    ) != -1
                                      ? "remove_circle_outline"
                                      : "add_circle_outline"}
                                  </span>
                                  <span
                                    className={
                                      this.state.buttonLearnMore ||
                                      this.state.expandLearn.indexOf(
                                        details.id
                                      ) != -1
                                        ? "hack"
                                        : "hack active"
                                    }
                                  >
                                    {" "}
                                    Leia mais
                                  </span>
                                  <span
                                    className={
                                      this.state.buttonLearnMore ||
                                      this.state.expandLearn.indexOf(
                                        details.id
                                      ) != -1
                                        ? "hack active"
                                        : "hack"
                                    }
                                  >
                                    {" "}
                                    Leia menos
                                  </span>
                                </a>
                                <div className="anotc__mp-result-item-top">
                                  <div className="anotc__mp-result-item-info">
                                    <p className="anotc__mp-result-item-name">
                                      {this.state.numbercliente}
                                    </p>
                                    <p className="anotc__mp-result-item-title">
                                      {details.usuario_anotacao}
                                    </p>
                                  </div>
                                  <div className="anotc__mp-result-item-critic">
                                    <span
                                      className={
                                        "anotc__mp-result-item-level " +
                                        details.class_criticality
                                      }
                                    >
                                      {details.desc_criticidade}
                                    </span>
                                    <span className="anotc__mp-result-item-fulltime">
                                      {details.data_anotacao +
                                        " - " +
                                        details.hora_anotacao}
                                    </span>
                                  </div>
                                </div>
                                <div
                                  className={
                                    this.state.buttonLearnMore ||
                                    this.state.expandLearn.indexOf(
                                      details.id
                                    ) != -1
                                      ? "anotc__mp-result-item-content auto"
                                      : "anotc__mp-result-item-content"
                                  }
                                >
                                  {details.desc_anotacao}
                                </div>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>

                    {/* <div className="flab">
                            <a href="#" className="flab__button">
                            <div className="material-icons">add</div>
                            </a>
                            <div className="flab__related">
                            <a href="#" className="btn--add-anotc flab__related__button tippy-default" onClick={event => this.toggleModal('modal__anotacoes-adicionar')} data-tippy-content="Adicionar uma anotação" data-tippy-theme="light" data-tippy-placement="left">
                                <div className="material-icons">note_add</div>
                            </a>
                            <a href="#" className="btn--search-anotc flab__related__button tippy-default" data-tippy-content="Adicionar em uma anotação" data-tippy-theme="light" data-tippy-placement="left">
                                <div className="material-icons">search</div>
                            </a>
                            </div>          
                            <div className="flab__overlay"></div>  
                        </div> */}
                  </main>
                </div>
              </div>
            </div>

            {/* Fim do Modal de Anotações */}

            <div
              className="modal micromodal-slide"
              id="modal__anotacoes-adicionar"
              aria-hidden="true"
              role="dialog"
            >
              <div className="modal__overlay" tabIndex="-1">
                <div
                  className="modal__container"
                  role="dialog"
                  aria-modal="true"
                  aria-labelledby="modal__anotacoes-adicionar__title"
                >
                  <header className="modal__header">
                    <h2
                      className="modal__title"
                      id="modal__anotacoes-adicionar__title"
                    >
                      Adicionar anotações
                    </h2>
                    <button
                      className="modal__close"
                      aria-label="Close modal"
                      data-micromodal-close
                    ></button>
                  </header>
                  <main
                    className="modal__content"
                    id="modal__anotacoes-adicionar__content"
                  >
                    <div className="andotc-add">
                      <div className="anotc-add__textarea">
                        <textarea
                          name="anotc-add__textarea__input"
                          id="anotc-add__textarea__input"
                          className="anotc-add__textarea__input"
                          ref={(input) => (this.comentarioAnotacoes = input)}
                        ></textarea>
                      </div>
                      <div className="anotc-add__panel">
                        <p className="anotc-add__text">
                          Qual a criticidade dessa anotação?
                        </p>
                        <div className="anotc-add__critic-wrapper">
                          <button
                            onClick={(event) =>
                              this.ShowCriticitysInsert(event)
                            }
                            className="anotc-add__critic-btn"
                          >
                            {this.state.criticidadeSelec}
                            <i className="anotc-add-critic-icon material-icons">
                              keyboard_arrow_down
                            </i>
                          </button>
                          <div
                            className={
                              this.state.buttonShowCriticitsIn
                                ? "anotc-add__critic-options anotc-add__critic-options__drop-top active"
                                : "anotc-add__critic-options anotc-add__critic-options__drop-top"
                            }
                          >
                            <ul className="anotc__mp-critic-list">
                              {this.state.DescAnotacoes.map((desc) => (
                                <li
                                  className="anotc__mp-critic-item"
                                  onClick={(event) =>
                                    this.ChangeCriticitys(
                                      event,
                                      desc.description,
                                      desc.id,
                                      desc.class_criticality
                                    )
                                  }
                                >
                                  <span
                                    className={
                                      "anotc__mp-critic-dot " +
                                      desc.class_criticality
                                    }
                                  >
                                    •
                                  </span>{" "}
                                  {desc.description}
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                        <button
                          className="anotc-add__save-btn"
                          onClick={(event) =>
                            this.SaveAnotation2(event, ContactId, InfoUsers)
                          }
                        >
                          Salvar anotação
                        </button>
                        <button
                          className="anotc-add__cancel-btn"
                          data-micromodal-close
                        >
                          Cancelar
                        </button>
                      </div>
                    </div>
                  </main>
                </div>
              </div>
            </div>
          </div>

          <div
            className="modal micromodal-slide"
            id="modal__anotacoes-salvo"
            aria-hidden="true"
            role="dialog"
          >
            <div className="modal__overlay" tabIndex="-1">
              <div
                className="modal__container"
                role="dialog"
                aria-modal="true"
                aria-labelledby="modal__anotacoes-salvo__title"
              >
                <header className="modal__header">
                  <h2
                    className="modal__title"
                    id="modal__anotacoes-salvo__title"
                  >
                    Anotações
                  </h2>
                  <button
                    className="modal__close"
                    aria-label="Close modal"
                    // onClick="toggleModal('modal__anotacoes')"
                    data-micromodal-close
                  ></button>
                </header>
                <main
                  className="modal__content"
                  id="modal__anotacoes-salvo__content"
                >
                  <form action="" className="modal__content__form">
                    <div className="modal__content__form__row">
                      <div className="modal__content__form__group modal__content__form__group--col-8">
                        <div className="modal__content-center">
                          <img src="build/images/add-note-success.png" alt="" />
                          <div className="modal-box__text-box">
                            <p className="modal-box__text-message">
                              Sua anotação foi salva
                            </p>
                            <p className="modal-box__text-message modal-box__text-message--bold">
                              com sucesso!
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal__content__form__group modal__content__form__group--col-2"></div>
                    <div className="modal__content__form__group modal__content__form__group--col-4">
                      <a
                        onClick={() =>
                          MicroModal.show("modal__anotacoes-adicionar")
                        }
                        className="modal__content__form__group__button"
                        data-micromodal-close
                      >
                        Voltar
                      </a>
                    </div>
                  </form>
                </main>
              </div>
            </div>
          </div>

          <input type="hidden" id="simulation_click" name="simulation_click" />
        </div>
        {(() => {
          if (monitorclient) {
            if (monitorclient.length != 0) {
              return (
                <Details
                  displayscreen={"monitoring"}
                  monitorclient={monitorclient}
                />
              );
            }
          }
        })()}
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Monitorias);
